import { Fragment } from "react";
import { Link, useLocation } from "react-router-dom";

const MENU = [
  { to: "/dashboard", icon: "fas fa-th-large", label: "Dashboard" },
  { to: "/student-dashboard", icon: "fa fa-pen", label: "Training" },
  { to: "/my-courses", icon: "fas fa-play", label: "My Courses" },
  { to: "/learning-history", icon: "fas fa-history", label: "Learning History" },
  { to: "/my-wishlist", icon: "far fa-heart", label: "My Wishlist" },
  { to: "/affiliate", icon: "fas fa-clone", label: "Affiliate" },
  { to: "/update-profile", icon: "fas fa-user-edit", label: "Update Profile" },
];

export default function SideBar() {
  const location = useLocation();

  let user = {};
  try {
    user = JSON.parse(localStorage.getItem("user_data")) || {};
  } catch (e) {
    user = {};
  }

  const initials = (user?.name || "Student")
    .split(" ")
    .map((part) => part.charAt(0))
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <Fragment>
      <nav
        className="sidebar customSidebar mb-4 mobile-offcanvas"
        id="navbar_main"
      >
        <div className="offcanvas-header">
          <button className="btn-close float-end" />
        </div>

        <div className="sidebarProfile">
          {user?.avatar ? (
            <img
              src={user.avatar}
              alt={user?.name || "Student"}
              className="sidebarProfileAvatar"
            />
          ) : (
            <span className="sidebarProfileAvatar sidebarProfileInitials">
              {initials}
            </span>
          )}
          <h6 className="sidebarProfileName">{user?.name || "Student"}</h6>
          {user?.email && (
            <span className="sidebarProfileEmail">{user.email}</span>
          )}
        </div>

        <ul className="nav flex-column">
          {MENU.map((item) => {
            const active = location.pathname === item.to;
            return (
              <li className="nav-item sidebarMenuItem" key={item.to}>
                <Link
                  className={`nav-link sidebarMenuLink ${active ? "active" : ""}`}
                  to={`${process.env.PUBLIC_URL}${item.to}`}
                >
                  <i className={`${item.icon} sidebarMenuIcon`} />
                  <span>{item.label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </Fragment>
  );
}
